export default __webpack_public_path__ + "static/media/services_enviro_2.405fe47d.jpg";